module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.70f9a0cf.jpg";